//域名
const env = import.meta.env;

export const BASE_FREIGHT_DOMAIN = env.VUE_APP_BASE_FREIGHT_DOMAIN;
export const BASE_USER_DOMAIN = env.VUE_APP_BASE_USER_DOMAIN;
export const BASE_BFF_DOMAIN = env.VUE_APP_BASE_BFF_DOMAIN;
export const BASE_BUSINESS_DOMAIN = env.VUE_APP_BASE_BUSINESS_DOMAIN;
export const BASE_THIRD_DOMAIN = env.VUE_APP_BASE_THIRD_DOMAIN;
export const BASE_INTERGRATION_DOMAIN = env.VUE_APP_INTERGRATION_BASE_URL;
export const BASE_SOCIAL_DOMAIN = env.VUE_APP_BASE_SOCIAL_URL;
export const BASE_MP_APPID = env.VUE_APP_BASE_MP_APPID;
export const BASE_MARKET_DOMAIN = env.VUE_APP_BASE_MARKET;
export const BASE_DATA_CENTER = env.VUE_APP_BASE_DATA_CENTER_URL;
export const BASE_AFTER_MALL_URL = env.VUE_APP_BASE_AFTER_MALL_URL;
